import { EN_DASH } from "./constants";

export function formatTicketName(
  ticketName: string,
  pricingTierName: string | null | undefined
) {
  return pricingTierName
    ? `${ticketName} ${EN_DASH} ${pricingTierName}`
    : ticketName;
}
